import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./~/rc-notification/es/index.js
// module id = 1115
// module chunks = 0